<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'EditBanner',
  mixins: [baseMixin],
  props: {
    editDescription: { type: String, default: '' },
  },
}
</script>

<template>
  <div class="edit-banner">
    <div class="d-flex banner">
      <v-icon size="20">mdi-alert-circle-outline</v-icon>
      <span class="edit-description">{{ editDescription }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';

.edit-banner {
  height: 45px;
  margin-top: 24px;
  background-color: $color-info-270;
  border-radius: 8px;

  .banner {
    padding: 12px 16px;
    gap: 12px;

    .v-icon {
      color: $color-blue-400 !important;
    }
    .edit-description {
      font-size: 14px;
      font-weight: 500;
      color: $color-blue-500;
      letter-spacing: 0.15px;
    }
  }
}
</style>
